export const isVariable = (s?: string) => typeof s === 'string' && s?.indexOf('var(') === 0;
export const getVariable = (s: string) => s.substring(4, s.length - 1);
